import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer className="bg-gradient-to-br from-teal-800 via-teal-900 to-[#0a3d4f] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-5 gap-8 md:gap-12 mb-8 md:mb-12">
          {/* Company Info */}
          <div className="col-span-2">
            <div className="flex items-center gap-3 mb-4 md:mb-6">
              <img
                src="https://static.readdy.ai/image/2299103fa86076f2ed06076e2d6cbff8/b0216ecd9824ced9791064a8a701a53c.png"
                alt="ROBO Asset Grid Logo"
                className="h-8 md:h-10 w-auto"
              />
            </div>
            <p className="text-sm md:text-base text-teal-200/80 leading-relaxed mb-4 md:mb-6 font-medium">
              A specialized company in smart digital water meters utilizing optical sensing technology, providing future-oriented metering solutions by combining eco-friendly materials and IoT technology.
            </p>
            <div className="space-y-1.5 md:space-y-2 text-sm md:text-base text-teal-200/70 font-medium">
              <p className="flex items-start gap-2">
                <i className="ri-map-pin-line text-teal-300 mt-0.5 flex-shrink-0"></i>
                <span>705, Sungkang Haeoreum, 32 Eungye-namgil, Siheung-si, Gyeonggi-do, Korea</span>
              </p>
              <p className="flex items-center gap-2">
                <i className="ri-phone-line text-teal-300 flex-shrink-0"></i>
                +82-31-313-2663
              </p>
              <p className="flex items-center gap-2">
                <i className="ri-smartphone-line text-teal-300 flex-shrink-0"></i>
                +82-10-3319-6611
              </p>
              <p className="flex items-center gap-2">
                <i className="ri-mail-line text-teal-300 flex-shrink-0"></i>
                tel9060@gmail.com
              </p>
              <p className="flex items-center gap-2">
                <i className="ri-printer-line text-teal-300 flex-shrink-0"></i>
                +82-504-229-7701
              </p>
            </div>
          </div>

          {/* Link Sections */}
          {[
            {
              title: 'Company',
              links: [
                { name: 'About Us', href: '#about' },
                { name: 'Business Plan', href: '#business-plan' },
                { name: 'Patents & Certifications', href: '#patents' },
              ],
            },
            {
              title: 'Products',
              links: [
                { name: 'Product Features', href: '#features' },
                { name: 'Generation Meters', href: '#generation-meter' },
                { name: 'Catalog', href: '#catalog' },
              ],
            },
            {
              title: 'Support',
              links: [
                { name: 'Contact Us', href: '#contact' },
                { name: 'Optical Sensor Meter', href: '#social-issues' },
                { name: 'Video Resources', href: '#video' },
              ],
            },
          ].map((section, idx) => (
            <div key={idx}>
              <h4 className="text-base md:text-lg font-black mb-3 md:mb-4 text-white">
                {section.title}
              </h4>
              <ul className="space-y-2 md:space-y-3">
                {section.links.map((link, lIdx) => (
                  <li key={lIdx}>
                    <a
                      href={link.href}
                      className="text-sm md:text-base text-teal-200/70 hover:text-teal-300 transition-colors duration-200 cursor-pointer font-medium"
                    >
                      {link.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Divider */}
        <div className="border-t border-teal-700/50 pt-6 md:pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 md:gap-6">
            {/* Copyright & Business Info */}
            <div className="text-center md:text-left">
              <p className="text-sm md:text-base text-teal-200/60 mb-1 md:mb-2 font-medium">
                &copy; 2024 ROBO Asset Grid. All rights reserved.
              </p>
              <p className="text-xs md:text-sm text-teal-200/40 font-medium">
                Business Registration: 123-45-67890 | CEO: Lee Dong-Woo
              </p>
              <div className="mt-2 flex items-center justify-center md:justify-start gap-3">
                <Link
                  to="/"
                  className="text-xs md:text-sm text-teal-200/60 hover:text-teal-300 transition-colors duration-200 cursor-pointer font-medium"
                >
                  한국어 버전
                </Link>
                <span className="text-teal-200/40">|</span>
                <a
                  href="https://readdy.ai/?ref=logo"
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  className="text-xs md:text-sm text-teal-200/40 hover:text-teal-300 transition-colors duration-200 cursor-pointer font-medium"
                >
                  Powered by Readdy
                </a>
              </div>
            </div>

            {/* Social Media Links */}
            <div className="flex items-center gap-3 md:gap-4">
              {[
                { icon: 'ri-facebook-fill', href: '#', label: 'Facebook' },
                { icon: 'ri-instagram-line', href: '#', label: 'Instagram' },
                { icon: 'ri-linkedin-fill', href: '#', label: 'LinkedIn' },
                { icon: 'ri-youtube-fill', href: '#', label: 'YouTube' },
              ].map((social, sIdx) => (
                <a
                  key={sIdx}
                  href={social.href}
                  aria-label={social.label}
                  rel="nofollow"
                  className="w-9 md:w-10 h-9 md:h-10 bg-white/10 hover:bg-teal-500 rounded-lg flex items-center justify-center transition-all duration-300 cursor-pointer group"
                >
                  <i
                    className={`${social.icon} text-base md:text-lg text-teal-200/70 group-hover:text-white`}
                  ></i>
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
